import { z } from 'zod';

import { firstPasswordRuleError } from '@/lib/auth/password-rules';

/** Valeurs du formulaire « Je modifie mon mot de passe ». */
export interface ChangeMotDePasseValues {
    old_password: string;
    password: string;
    password_confirmation: string;
}

const REQUIRED_FIELDS = ['old_password', 'password', 'password_confirmation'] as const;

export const changeMotDePasseSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;
    const errors: Record<string, string> = {};

    for (const field of REQUIRED_FIELDS) {
        if (!v[field]) errors[field] = 'Le champ est obligatoire';
    }

    if (v['password'] && v['password_confirmation'] && v['password'] !== v['password_confirmation']) {
        errors['password'] = "la confirmation du mot de passe n'est pas valide";
        errors['password_confirmation'] = "la confirmation du mot de passe n'est pas valide";
    }

    // Règles PASS, partagées avec « Nouveau mot de passe » et appliquées après la
    // concordance, comme là-bas : le défaut du mot de passe lui-même s'affiche en premier.
    if (v['password']) {
        const ruleError = firstPasswordRuleError(String(v['password']));

        if (ruleError) {
            errors['password'] = ruleError;
        }
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
